import React from "react";
import keys from "configs/constants";

const ProductLogo = ({ className, logoWidth, noText }) => {
  let clsName = "pt-0 pb-0 text-center d-flex-sm flex-column ";
  if (className !== undefined) {
    clsName += className;
  }

  return (
    <div className={clsName} style={{ whiteSpace: "normal" }}>
      <img
        alt="Logo"
        className={"navbar-brand-img  " + (logoWidth ?? "")}
        src={keys.LOGO_URL}
      />
      {!noText && (
        <>
          <h5 className="d-none d-md-block text-center text-dark product-logo-text mt-2">
            {/* Foodservice for big displays */}
            {keys.PRODUCT_NAME}
          </h5>
          <h5 className="d-md-none text-center text-dark product-logo-text mt-2">
            {/* Foodservice Name for small displays */}
            {keys.PRODUCT_NAME}
          </h5>
        </>
      )}
    </div>
  );
};

export default ProductLogo;
